import { render, staticRenderFns } from "./IndustryCategory.vue?vue&type=template&id=c4fc0034&scoped=true&"
import script from "./IndustryCategory.vue?vue&type=script&lang=js&"
export * from "./IndustryCategory.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCategory.vue?vue&type=style&index=0&id=c4fc0034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fc0034",
  null
  
)

export default component.exports